<template>
  <div class="header">
    <img src="@/assets/img/logo.png" style="width:2.8em" @click="GotoLogin">
    <div class="likeInput" @click="GoToSearch">
        <img src="@/assets/img/header/icon_navi_search.png" style="width:1.6rem"/>    
    </div>   
    <div>
        <img src="@/assets/img/header/icon_navi_right_comment.png" style="width:1.4rem">
        <img src="@/assets/img/header/icon_navi_right_scan.png" style="width:1.4rem;margin-left:0.5rem">
    </div>
  </div>
</template>

<script>
export default{
  props:[''],
  methods:{
    GoToSearch(){
      this.$router.push({ path: `/search` })
    },
    GotoLogin(){
      let token = window.localStorage.getItem('x-token')
      if(token){
        this.$router.push({ path: `/personal` })
      }else{
        this.$router.push({ path: `/login/login` })
      }
    }
  }
}
</script>
<style>
.header{
    position: fixed;
    top: 0px;
    height: 3rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0rem 1rem;
    border-bottom: 1px solid #ccc;
    z-index: 9;
    background: #ffffff
}
.likeInput{
    width: 12rem;
    background: #eae9e9;
    height: 2.4rem;
    border-radius: 2.4rem;
    padding-left:1.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start
}
</style>